// @ts-nocheck
import { ApiParameters } from "@store/Framework/Common/Hooks/useReportAPI/useReportAPI";

export const isInvoiceSummaryError = (apiParameters: ApiParameters) => {
    if ("dateType" in apiParameters) {
        return (
            apiParameters.sourceType &&
            apiParameters.billableTreatment &&
            apiParameters.dateType &&
            apiParameters.customers.length > 0
        );
    }
    return false;
};
export const isReportFrequencyError = (apiParameters: ApiParameters) => {
    if ("customers" in apiParameters) {
        if (apiParameters.customers.length > 0) {
            return true;
        }
    }
    return false;
};
export const isPoPickerError = (apiParameters: ApiParameters) => {
    if ("customers" in apiParameters) {
        return apiParameters.customers.length > 0;
    }

    return false;
};
export const isExpendituresByManufacturersError = (apiParameters: ApiParameters) => {
    if ("customers" in apiParameters) {
        return apiParameters.customers.length > 0;
    }
    return false;
};
export const isBudgetSummaryError = (apiParameters: ApiParameters) => {
    if ("customers" in apiParameters && "billableTreatment" in apiParameters) {
        return apiParameters.customers.length > 0 && apiParameters.billableTreatment;
    }
};

export const ismonthlyExpenseComparisonError = (apiParameters: ApiParameters) => {
    if ("customers" in apiParameters) {
        return apiParameters.customers.length > 0;
    }
    return false;
};

export const isExpendituresError = (apiParameters: ApiParameters) => {
    if ("customers" in apiParameters) {
        return apiParameters.customers.length > 0;
    }
    return false;
};
